export default "__VITE_ASSET__BVqtVB1n__"